<template lang="pug">
OrderActionModal(v-if="show" :show="show" max-width="min(100vw - 2rem, 34rem)" @close="onClose")
  template(slot="header")
    span.remit-data-modal__title.uppercase Remites · {{ recordLabel }}

  .remit-data-modal
    .remit-data-modal__actions
      shActionButton(
        :action="regenerateRemit"
        text="Regenerar remite"
        textRunning="Regenerando remite"
        :normalColor="true"
      )
      p.remit-data-modal__message(v-if="actionMessage" class="is-ok") {{ actionMessage }}

    RemitDataList(:record="recordData")
</template>

<script>
import gql from '@my/graphql'
import gqlOrder from '@/graphql/order'
import modals from '@my/store/modals'
import OrderActionModal from '@/components/pages/order/refund/OrderActionModal.vue'
import RemitDataList from '@/components/elements/remit/RemitDataList.vue'
import shActionButton from '@/components/elements/ActionButton.vue'
import { recordHasRemit } from '@/helpers/remit'

export default {
  name: 'RemitDataModal',

  components: {
    OrderActionModal,
    RemitDataList,
    shActionButton
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    order: {
      type: Object,
      default: null
    },
    record: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      actionMessage: ''
    }
  },

  computed: {
    recordData () {
      return this.record || this.order
    },

    recordLabel () {
      if (!this.recordData) return ''
      if (this.recordData.change) return `c${this.recordData.change}`
      return this.recordData.order || ''
    },

    isChange () {
      return !!(this.recordData && this.recordData.change)
    }
  },

  watch: {
    show (visible) {
      if (!visible) {
        this.actionMessage = ''
      }
    }
  },

  methods: {
    onClose () {
      this.$emit('close')
    },

    async regenerateRemit () {
      if (!this.recordData || !recordHasRemit(this.recordData)) return

      this.actionMessage = ''

      const variables = this.isChange
        ? { change: this.recordData.change }
        : { order: this.recordData.order }

      const errors = []
      const response = await gql.mutate(
        gqlOrder.GENERATE_REMIT_DATA,
        variables,
        false,
        errors
      )

      if (!response || response.error) {
        modals.showMessage({
          message: this.formatError((response && response.error) || errors[0]),
          type: 'error'
        })
        return
      }

      const result = response.data.generateRemitData

      if (!result || !result.success) {
        modals.showMessage({
          message: (result && result.message) || 'Error al regenerar remite',
          type: 'error'
        })
        return
      }

      const message = result.message || 'Remite regenerado'
      this.actionMessage = message
      modals.showMessage({ message })
      this.applyRemitUpdate(result)
    },

    applyRemitUpdate (result) {
      if (!result) return

      this.$store.dispatch('orderNovelty/applyRemitUpdate', result)

      if (this.recordData && result.remitData) {
        this.$set(this.recordData, 'remitData', result.remitData)
        this.$set(this.recordData, 'remitDataGenerated', !!result.remitDataGenerated)
        if (result.dataLocked !== undefined) {
          this.$set(this.recordData, 'dataLocked', !!result.dataLocked)
        }
      }

      if (result.order) {
        this.$store.commit('pack/updatePackOrderFromSocket', result)
      }

      if (result.change) {
        this.$store.commit('pack/updatePackChangeFromSocket', result)
      }
    },

    formatError (error) {
      if (!error) return 'No hubo respuesta del servidor'
      if (typeof error === 'string') return error
      if (error.message) return error.message
      return String(error)
    }
  }
}
</script>

<style lang="stylus" scoped>
.remit-data-modal
  padding 0 1.5rem 1.5rem
  overflow-y auto
  max-height calc(100vh - 8rem)

.remit-data-modal__title
  font-size 1rem
  font-weight 600

.remit-data-modal__actions
  display flex
  flex-direction column
  align-items flex-start
  gap .75rem
  margin-bottom 1.5rem
  padding-bottom 1.5rem
  border-bottom 1px solid var(--color-border)

.remit-data-modal__message
  margin 0
  font-size .9rem
  color var(--color-font-principal)
</style>



// WEBPACK FOOTER //
// src/components/elements/remit/RemitDataModal.vue